export default function Icon({ icon, size = 20, className="text-2xl", onClick, ref }) {
    if (!icon) return null;

    const parts = icon.split(" ");

    // Material Symbols use the mi token.
    if (parts.includes("mi")) {
        const miToken = parts.find(p => p.startsWith("mi:"));
        const iconName = miToken ? miToken.replace("mi:", "") : "";

        return (
            <i
                ref={ref}
                className={`z-icon mi ${className} ${onClick&&"cursor-pointer"}`}
                onClick={onClick}
                data-icon={iconName}
                style={{ fontSize: size }}
            />
        );
    }

    // PrimeIcons use the pi token.
    if (parts.includes("pi")) {
        return <i ref={ref} className={`z-icon ${icon} ${className} ${onClick&&"cursor-pointer"}`} onClick={onClick} style={{ fontSize: size }} />;
    }

    // Font Awesome icons use the fa token.
    if (parts.includes("fa")) {
        return <i ref={ref} className={`z-icon ${icon} ${className} ${onClick&&"cursor-pointer"}`} onClick={onClick} style={{ fontSize: size }} />;
    }

    return null;
}
